/* eslint-disable @typescript-eslint/indent */
import { Button, ButtonGroup, Text, useToast, VStack } from "@chakra-ui/react"
import React from "react"
import { NavLink, useNavigate } from "react-router-dom"
import { ExtendedUserFragment, useUnassignPhoneDeviceMutation } from "../graphql"

export type UnassignPhoneDeviceFormProps = {
	user: ExtendedUserFragment
}

export const UnassignPhoneDeviceForm: React.FC<UnassignPhoneDeviceFormProps> = ({ user }) => {
	const [{ fetching }, unassignPhoneDevice] = useUnassignPhoneDeviceMutation()
	const toast = useToast()
	const navigate = useNavigate()

	const handleUnassign = async () => {
		const { data, error } = await unassignPhoneDevice({ userId: user._id })

		if (error) {
			toast({ description: error.message.replace("[GraphQL] ", ""), status: "error" })
			return
		}

		if (data?.unassignPhoneDevice) {
			toast({ description: "Phone device unassigned successfully", status: "success" })
			navigate(`/users/${user._id}`)
		} else {
			toast({ description: "Couldn't unassign the phone device", status: "error" })
		}
	}

	return (
		<VStack w="full" maxW={{ base: "full", xl: "2xl" }} align="stretch" spacing={4}>
			<VStack w="full" align="flex-end" spacing={4}>
				<Text fontSize="sm" color="grayscale.label" alignSelf="flex-start">
					Are you sure you want to unassign the phone device from {user.name}?
				</Text>
				<ButtonGroup>
					<Button size="sm" as={NavLink} to={`/users/${user._id}`}>
						Cancel
					</Button>
					<Button size="sm" colorScheme="error" isLoading={fetching} onClick={handleUnassign}>
						Unassign
					</Button>
				</ButtonGroup>
			</VStack>
		</VStack>
	)
}
